import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { SiteServices } from '../../services/siteservices';
import { PaginationModule } from 'ngx-bootstrap';
import { TabsModule } from 'ngx-bootstrap';
import { ModalModule } from 'ngx-bootstrap/modal';

import { AlertModule } from 'ngx-bootstrap/alert';
import { RouteReuseStrategy } from '@angular/router';
import { PRODUCTLIST_ROUTER_PROVIDERS } from './productlist.routes';

import { CustomReuseStrategy } from '../common/route.reuse';

import { ProductListComponent } from './productlist.main';
import { ProductList } from './productlist.list';

import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { HttpClientModule } from '@angular/common/http';
import { CKEditorModule } from 'ckeditor4-angular';
import { ProductDetailModule } from '../productdetail/productdetail.module';

@NgModule({
    declarations: [ProductListComponent, ProductList],
    imports: [
        BrowserModule,
        PRODUCTLIST_ROUTER_PROVIDERS,
        CKEditorModule,
        FormsModule,
        HttpModule,
        HttpClientModule,
        ProductDetailModule,
        PaginationModule.forRoot(),
        AlertModule.forRoot(),
        ModalModule.forRoot(),
        TabsModule.forRoot(),
        MDBBootstrapModule.forRoot(),
    ],
    providers: [
        SiteServices,
        { provide: RouteReuseStrategy, useClass: CustomReuseStrategy },
    ],
    bootstrap: [ProductListComponent],
})
export class ProductListModule {}
